import 'css-chunk:src/feature/cash-bank/CashBankEditCloseBank.module.scss';export default {
  "summary-report": "CashBankEditCloseBank_summary-report"
};